module.exports = __webpack_public_path__ + "static/Contact-699ccac0c269763236a7a777ae5b0bb1.png";